<script>
	import Lotto from "../stores/Lotto-contract-store";
	import Exchange from "../stores/Exchanage-contract-store";
	import { Tabs, Tab, TabList, TabPanel } from "../Tabs/tabs";
	import { ETHER_Address} from "../helpers";
	import { orders } from "../stores/oders-store";
	import { web3, selectedAccount } from "svelte-web3";

	let buyOrder = {};
	let sellOrder = {};

	function makeSellOrder(order) {
		const tokenGet = ETHER_Address;
		const amountGet = $web3.utils.toWei(
			(order.amount * order.price).toString(),
			"ether"
		);
		const tokenGive = $Lotto.options.address;
		const amountGive = $web3.utils.toWei(order.amount, "ether");

		$Exchange.methods
			.makeOrder(tokenGet, amountGet, tokenGive, amountGive)
			.send({ from: $selectedAccount })
			.on("transactionHash", (hash) => {})
			.on("receipt", (hash) => {
				sellOrder = {}
			})
			.on("error", (error) => {
				console.error(error);
				window.alert(`There was an error!`)
			})
	}
	function makeBuyOrder(order) {
		const tokenGet = $Lotto.options.address;
		const amountGet = $web3.utils.toWei(order.amount, "ether")
		const tokenGive = ETHER_Address
		const amountGive = $web3.utils.toWei(
			(order.amount * order.price).toString(),
			"ether"
		)

		$Exchange.methods
			.makeOrder(tokenGet, amountGet, tokenGive, amountGive)
			.send({ from: $selectedAccount })
			.on("transactionHash", (hash) => {})
			.on("receipt", (hash) => {
				buyOrder = {};
			})
			.on("error", (error) => {
				console.error(error);
				window.alert(`There was an error!`);
			});
	}
	
</script>

{#if $orders}
	<Tabs>
		<TabList>
			<Tab>Buy</Tab>
			<Tab>Sell</Tab>
		</TabList>
		<TabPanel>
			<br />
			<form on:submit|preventDefault={makeBuyOrder(buyOrder)}>
				<div class="form-group small mb-2">
					<label for input-group class="mb-2">Buy Amount (LTT)</label>
					<div class="input-group">
						<input
							type="text"
							class="form-control form-control-sm bg-dark text-white"
							placeholder="Buy Amount"
							required
							bind:value={buyOrder.amount}
						/>
					</div>
				</div>
				<div class="form-group small mb-2">
					<label for input-group class="mb-2">Buy Price</label>
					<div class="input-group">
						<input
							type="text"
							class="form-control form-control-sm bg-dark text-white"
							placeholder="Buy Price"
							required
							bind:value={buyOrder.price}
						/>
					</div>
				</div>
				{#if buyOrder.amount >= 0 && buyOrder.price >= 0}
					{(buyOrder.amount * buyOrder.price).toFixed(4)} ETH <br />
				{/if}
				<button
					type="submit"
					class="btn btn-outline-success btn-sm btn-block mt-2"
					>Buy Order</button
				>
			</form>
		</TabPanel>

		<TabPanel>
			<br />
			<form on:submit|preventDefault={makeSellOrder(sellOrder)}>
				<div class="form-group small mb-2">
					<label for input-group class="mb-2">Sell Amount (LTT)</label
					>
					<div class="input-group">
						<input
							type="text"
							class="form-control form-control-sm bg-dark text-white"
							placeholder="Sell amount"
							required
							bind:value={sellOrder.amount}
						/>
					</div>
				</div>
				<div class="form-group small mb-2">
					<label for input-group class="mb-2">Sell Price</label>
					<div class="input-group">
						<input
							type="text"
							class="form-control form-control-sm bg-dark text-white"
							placeholder="Sell Price"
							required
							bind:value={sellOrder.price}
						/>
					</div>
				</div>
				{#if sellOrder.amount >= 0 && sellOrder.price >= 0}
					{(sellOrder.amount * sellOrder.price).toFixed(4)} ETH <br />
				{/if}
				<button
					type="submit"
					class="btn btn-outline-danger btn-sm btn-block mt-2"
					>Sell Order</button
				>
			</form>
		</TabPanel>
	</Tabs>
{/if}
